import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { createBrowserHistory } from 'history';
import { ApolloConsumer } from 'react-apollo';
import { Button, colors, Typography } from '@material-ui/core';

import Spinner from './Spinner';
import ChangePasswordDialog from './dialogs/ChangePasswordDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  name: {
    marginTop: theme.spacing(1)
  },
  button: {
    color: colors.blueGrey[800],
    padding: '5px 4px',
    justifyContent: 'flex-center',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  }
}));

const Profile = (props) => {
  const { className, session } = props;
  const [openChangePasswordDialog, setOpenChangePasswordDialog] = useState(false);
  const classes = useStyles();

  const handleChangePasswordDialogOpen = () => {
    console.log("handleChangePasswordDialogOpen");
    setOpenChangePasswordDialog(true);
  };

  const handleCHangePasswordDialogClose = () => {
    setOpenChangePasswordDialog(false);
  };

  return !session ? (<Spinner />):(
    <div className={clsx(classes.root, className)}>
      <ChangePasswordDialog
        open={openChangePasswordDialog}
        onClose={handleCHangePasswordDialogClose}
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {(session.currentUser !== null ? session.currentUser.name : '')}
      </Typography>

      <Button className={classes.button} onClick={handleChangePasswordDialogOpen}>
        {/* <div className={classes.icon}><SettingsIcon /></div> */}
        Passwort ändern
      </Button>
      <SignOutButton />
    </div>
  );
};

const history = createBrowserHistory();

const logout = (client) => {
  localStorage.removeItem('token');
  client.resetStore();
  history.push('/login');
};

const SignOutButton = () => (
  <ApolloConsumer>
    {(client) => (
      <a onClick={() => logout(client)} href="/login">
        <Typography variant="body2">Abmelden</Typography>
      </a>
    )}
  </ApolloConsumer>
);

Profile.propTypes = {
  className: PropTypes.string,
  session: PropTypes.object
};

export default Profile;
